/**
 * This can not be done using a composable as defineProps has a different scope than the rest of the setup script.
 */

import uuid from '../../../helpers/uuid';

export const defaultProps = {
    label: {
        type: String,
        default: null,
    },

    name: {
        type: String,
        default: uuid(20),
    },

    required: {
        type: [Boolean, String],
        default: false,
    },

    message: {
        type: String,
        default: null,
    },

    errorMessage: {
        type: String,
        default: null,
    },
};

export const defaultFieldProps = {
    ...defaultProps,

    placeholder: {
        type: String,
        required: false,
        default: null,
    },
};
